/**
 * React error-boundary that pipes uncaught render errors through Forge.
 * `captureGlobalErrors()` already covers `window.onerror` /
 * `unhandledrejection`; this fills the React render-tree gap.
 */
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { trackError } from './client';

type Props = { children: ReactNode; fallback?: ReactNode };
type State = { hasError: boolean };

export class AnalyticsErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    trackError(error, { handled: false, data: { componentStack: info.componentStack ?? '' } });
  }

  override render() {
    if (this.state.hasError) return this.props.fallback ?? null;
    return this.props.children;
  }
}
